<template>
  <div v-if="showUpdateTip" class="version-update-tip">
    <div class="update-modal">
      <div class="update-content">
        <h3>🎉 版本更新提醒</h3>
        <p>发现新版本可用：</p>
        <ul>
          <li>当前版本：{{ localVersion.version || '未知' }}</li>
          <li>最新版本：{{ serverVersion.version || '未知' }}</li>
          <li>发布时间：{{ serverVersion.buildTimeStr || '未知' }}</li>
        </ul>
        <p>为了获得更好的体验，请及时更新！</p>
        <div class="update-actions">
          <button class="btn-cancel" @click="closeUpdateTip">暂不更新</button>
          <button class="btn-update" @click="handleUpdate">立即更新</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchServerVersion, getLocalVersion, clearAppCache } from '@/utils/versionCheck'

export default {
  name: 'VersionUpdateTip',
  data() {
    return {
      showUpdateTip: false,
      serverVersion: {},
      localVersion: {}
    }
  },
  mounted() {
    this.checkVersion()
  },
  methods: {
    async checkVersion() {
      try {
        this.localVersion = getLocalVersion() || {}
        this.serverVersion = await fetchServerVersion() || {}
        
        // 判断是否需要显示更新提示
        if (this.localVersion.version && this.serverVersion.version) {
          const needUpdate = this.serverVersion.version !== this.localVersion.version ||
                           this.serverVersion.buildTime !== this.localVersion.buildTime
          
          if (needUpdate) {
            this.showUpdateTip = true
          }
        }
      } catch (error) {
        console.error('版本检查失败：', error)
      }
    },
    closeUpdateTip() {
      this.showUpdateTip = false
    },
    handleUpdate() {
      // 清除缓存并刷新页面
      clearAppCache()
      // 强制刷新页面，带时间戳防止缓存
      window.location.href = window.location.href.split('?')[0] + '?t=' + Date.now()
    }
  }
}
</script>

<style scoped>
.version-update-tip {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.update-modal {
  background: white;
  border-radius: 8px;
  padding: 20px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.update-content h3 {
  margin-top: 0;
  color: #409EFF;
  text-align: center;
}

.update-content ul {
  padding-left: 20px;
  margin: 15px 0;
}

.update-content li {
  margin: 8px 0;
  color: #606266;
}

.update-content p {
  color: #606266;
  text-align: center;
}

.update-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.btn-cancel, .btn-update {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-cancel {
  background-color: #909399;
  color: white;
}

.btn-cancel:hover {
  background-color: #7a7f85;
}

.btn-update {
  background-color: #409EFF;
  color: white;
}

.btn-update:hover {
  background-color: #66b1ff;
}
</style>


// WEBPACK FOOTER //
// src/components/VersionUpdateTip.vue